import React from 'react';
import "./CardTable.scss";
import { formatStringNumber } from '../../../services/Helpers/fonctions';
function CardTable({ data }) {
  const montanttva = !isNaN(data.prix) ? Math.round(parseFloat(data.prix) - (data.prix / (1 + 18/100))) : 0;
  return (
    <div className="cart-table" style={{ overflowX:'unset'}}>
       <table style={{ minWidth:0}}>
          <thead className="table-header">
            <tr>
              <th>Description</th>
              <th>Chassis</th>
              <th>N°Imm</th>
              <th>Prix (en fg)</th>
            </tr>
          </thead>
          <tbody>
             <tr>
                <td>{ data?.nomCategorie ? data?.nomCategorie : data.name + " (Montant HT)"}</td>
                <td>{ data?.chassis?.toUpperCase() }</td>
                <td>{ data?.numImmat?.toUpperCase() || "---" }</td>
                <td align='right'>{ !isNaN(data?.prix) ? formatStringNumber(Math.round(data.prix || data.price / (1 + 18/100) * 100 / 100) - montanttva) : 0}</td>
             </tr>
             {/* isNaN(item.price) ? formatStringNumber((parseFloat(item.price) - (item.price / (1 + 18/100))).toFixed(2)) : 0 */}
             <tr>
               <td>Montant TVA (18%)</td>
               <td colSpan={3} align='right'>{  formatStringNumber(montanttva) }</td>
             </tr>
          </tbody>
        </table>  
    </div>
  )
}

export default CardTable;